import { AccountCircleOutlined, Add, ArrowRightAlt, Delete, Description, Edit, FolderOutlined, MoreHoriz } from '@mui/icons-material';
import { Avatar, Box, Button, Chip, Divider, Fab, IconButton, Typography } from '@mui/material'
import StoryPreview from '../userStory/StoryPreview.js';
import { useApplicationContext } from '../../context/ApplicationContext.js';
import CreateStoryDialog from '../dialog/CreateStoryDialog.js';
import { useState } from 'react';
import { blue, brown, green, grey, purple, red, yellow } from '@mui/material/colors';
import { font } from '../../styles/font.js';
import ExecutionCard from './ExecutionCard.js';

class EXECUTION_STATUS {
    static PENDING = "Pending";
    static IN_PROGRESS = "In progress";
    static COMPLETED = "Completed";
    static FAILED = "Failed";
    static INTERUPPTED = "Interrupted";
}

function ExecutionContainer() {
    const { currentUserStory, setCurrentUserStory, openStoryPreview, setOpenStoryPreview } = useApplicationContext();

    const [currentStoryFilter, setCurrentStoryFilter] = useState("all");


    let executionList = [
        {
            name: "Create a new user profile",
            description: "The user is on the sign up page. The user enters the required information such as name, email, password, and phone number. The user should be able to create a new user profile with the required information such as name, email, password, and phone number.",
            type: "story",
            id: 1,
            status: EXECUTION_STATUS.PENDING,
            acceptanceCriteria: [
                "The user should be able to create a new user profile with the required information such as name, email, password, and phone number.",
                "The user should not be able to create a new user profile if the required information is not provided.",
                "The user should not be able to create a new user profile if the email address already exists."
            ]
        },
        {
            name: "Log in to the service",
            description: "The user is on the login page. The user enters the email address and password. The user should be able to log in to the service with the email address and password.",
            type: "story",
            id: 2,
            status: EXECUTION_STATUS.IN_PROGRESS,
            acceptanceCriteria: [
                "The user should be able to log in to the service with the email address and password.",
                "The user should not be able to log in to the service if the email address or password is incorrect.",
                "The user should not be able to log in to the service if the email address does not exist."
            ]
        },
        {
            name: "Reset password",
            description: "The user is on the reset password page. The user enters the email address. The user should be able to reset the password with the email address.",
            type: "story",
            id: 3,
            status: EXECUTION_STATUS.COMPLETED,
            acceptanceCriteria: [
                "The user should be able to reset the password with the email address.",
                "The user should not be able to reset the password if the email address does not exist."
            ]
        },
        {
            name: "Shopping Website",
            description: "The user is on the shopping website. The user places an order. The user should receive a confirmation message after placing an order.",
            type: "project",
            id: 4,
            status: EXECUTION_STATUS.FAILED,
            acceptanceCriteria: [
                "The platform should allow users to browse products.",
                "The platform should provide a secure checkout process.",
                "The platform should have an admin panel to manage products."
            ]
        },
        {
            name: "Banking App",
            description: "The user is on the banking app. The user logs in. The user should be able to log in to the banking app.",
            type: "project",
            id: 5,
            status: EXECUTION_STATUS.INTERUPPTED,
            acceptanceCriteria: [
                "The app should allow users to check their account balance.",
                "The app should enable users to transfer money securely.",
                "The app should provide transaction history and notifications."
            ]
        },
        {
            name: "Create a new project",
            description: "The user is on the project page. The user enters the name and description of the project. The user should be able to create a new project with the required information such as name and description.",
            type: "story",
            id: 6,
            status: EXECUTION_STATUS.PENDING,
            acceptanceCriteria: [
                "The user should be able to create a new project with the required information such as name and description.",
                "The user should not be able to create a new project if the required information is not provided.",
                "The user should not be able to create a new project if the project name already exists."
            ]
        },
        {
            name: "Edit a project",
            description: "The user is on the edit project page. The user enters the name and description of the project. The user should be able to edit the project with the required information such as name and description.",
            type: "story",
            id: 7,
            status: EXECUTION_STATUS.IN_PROGRESS,
            acceptanceCriteria: [
                "The user should be able to edit the project with the required information such as name and description.",
                "The user should not be able to edit the project if the required information is not provided.",
                "The user should not be able to edit the project if the project name already exists."
            ]
        }
    ];

    function GetExecutionStatusFilterLength(story_status) {

        switch (story_status?.toLowerCase()) {
            case EXECUTION_STATUS.PENDING?.toLowerCase():
                return executionList
                    ?.filter((item) => item?.type === "story")
                    ?.filter((item) => item?.status?.toLowerCase() === EXECUTION_STATUS.PENDING?.toLowerCase())?.length
            case EXECUTION_STATUS.IN_PROGRESS?.toLowerCase():
                return executionList
                    ?.filter((item) => item?.type === "story")
                    ?.filter((item) => item?.status?.toLowerCase() === EXECUTION_STATUS.IN_PROGRESS?.toLowerCase())?.length
            case EXECUTION_STATUS.INTERUPPTED?.toLowerCase():
                return executionList
                    ?.filter((item) => item?.type === "story")
                    ?.filter((item) => item?.status?.toLowerCase() === EXECUTION_STATUS.INTERUPPTED?.toLowerCase())?.length
            case EXECUTION_STATUS.COMPLETED?.toLowerCase():
                return executionList
                    ?.filter((item) => item?.type === "story")
                    ?.filter((item) => item?.status?.toLowerCase() === EXECUTION_STATUS.COMPLETED?.toLowerCase())?.length
            case EXECUTION_STATUS.FAILED?.toLowerCase():
                return executionList
                    ?.filter((item) => item?.type === "story")
                    ?.filter((item) => item?.status?.toLowerCase() === EXECUTION_STATUS.FAILED?.toLowerCase())?.length
            default:
                return executionList?.filter((item) => item?.type === "story")?.length;
        }
    }

    function GetExecutionStatusColor(execution_status) {
        // console.log(story_status, "story_status")
        switch (execution_status?.toLowerCase()) {
            case EXECUTION_STATUS.PENDING?.toLowerCase():
                return yellow[500];
            case EXECUTION_STATUS.IN_PROGRESS?.toLowerCase():
                return blue[500];
            case EXECUTION_STATUS.INTERUPPTED?.toLowerCase():
                return brown[500];
            case EXECUTION_STATUS.COMPLETED?.toLowerCase():
                return green[500];
            case EXECUTION_STATUS.FAILED?.toLowerCase():
                return red[500];
            default:
                return grey[500];
        }
    }


    const handleOpenStory = (story) => {
        setCurrentUserStory(story);
        setOpenStoryPreview(true);
    }

    return (
        <Box className=" flex flex-col gap-4 relative h-full w-full box-border overflow-hidden">

            {/* header */}
            <Box className="w-full flex justify-between">
                <Typography variant="h6">Execution</Typography>


                <Box className="flex items-center gap-2">
                    <Avatar sx={{ width: "25px", height: "25px", bgcolor: purple[500], fontSize: "14px" }}>
                        {executionList
                            ?.filter((item) => item?.type === "story")?.length
                            ?.toString()}
                    </Avatar>

                    <Divider orientation="vertical" flexItem />

                    {
                        [
                            "all",
                            EXECUTION_STATUS.COMPLETED,
                            EXECUTION_STATUS.FAILED,
                            EXECUTION_STATUS.IN_PROGRESS,
                            EXECUTION_STATUS.INTERUPPTED,
                            EXECUTION_STATUS.PENDING,
                        ]
                            ?.map((item, index) => (
                                <Chip
                                    key={index}
                                    variant={currentStoryFilter === item?.toLowerCase() ? "filled" : "outlined"}
                                    size="small"
                                    label={`${item}
                                    (${GetExecutionStatusFilterLength(item?.toLowerCase())})`}
                                    className="transition-all ease-in-out duration-300 cursor-pointer capitalize"
                                    onClick={() => setCurrentStoryFilter(item?.toLowerCase())}
                                    sx={{ color: currentStoryFilter === item?.toLowerCase() ? "white" : GetExecutionStatusColor(item?.toLowerCase()), background: currentStoryFilter === item?.toLowerCase() && GetExecutionStatusColor(item?.toLowerCase()), "&:hover": { background: currentStoryFilter === item?.toLowerCase() && GetExecutionStatusColor(item?.toLowerCase()) } }}
                                />
                            ))

                    }

                </Box>
            </Box>

            {/* story list */}
            <Box className=" grow flex  flex-col gap-4">

                {/* list container */}
                <Box className=" grow flex  overflow-y-auto ">
                    {executionList
                        ?.filter((item) => item?.type === "story")?.length === 0 ?
                        <Box className="grow flex flex-col gap-2 justify-center items-center ">
                            <Description sx={{ fontSize: font.size.fs_1 }} />
                            <Typography fontSize={font.size.fs_5}>No execution</Typography>
                        </Box>
                        :
                        (
                            executionList
                                ?.filter((item) => item?.type === "story")
                                ?.filter((item) => currentStoryFilter === "all" ? true : item?.status?.toLowerCase() === currentStoryFilter)?.length === 0 ?
                                (
                                    <Box className="grow flex flex-col gap-2 justify-center items-center ">
                                        <Description sx={{ fontSize: font.size.fs_1 }} />
                                        <Typography fontSize={font.size.fs_5}>No {currentStoryFilter} execution</Typography>
                                    </Box>
                                ) :

                                (
                                    <Box className=" min-w-full h-fit flex flex-wrap gap-6 ">
                                        {
                                            executionList
                                                ?.filter((item) => item?.type === "story")
                                                ?.filter((item) => currentStoryFilter === "all" ? true : item?.status?.toLowerCase() === currentStoryFilter)
                                                ?.map((item, index) => {
                                                    return (
                                                        <Box
                                                            // className="bg-white rounded-lg shadow hover:shadow-lg transition-all ease-in-out duration-300 cursor-pointer h-fit min-w-[150px] w-[100%] sm:w-[48%] md:w-[31%] lg:w-[24%] xl:w-[18%] 2xl:w-[18.6%]"
                                                            className="bg-white overflow-hidden rounded-lg border  hover:shadow-xl transition-all ease-in-out duration-300 h-[115px] min-w-[120px] w-[98%] sm:w-[47%] md:w-[31%] lg:w-[23%]"
                                                            key={index}
                                                        >
                                                            <ExecutionCard item={item} handleClick={handleOpenStory} />
                                                        </Box>
                                                    )
                                                })
                                        }

                                    </Box>
                                )
                        )
                    }
                </Box>
            </Box>

        </Box>
    )
}

export default ExecutionContainer
